import React, {useState} from 'react'
import {useSelector, useDispatch} from "react-redux";
import {SketchPicker} from 'react-color'
import {applyAccountOrganizationChanges, clearHotspot} from "../../actions";
import AjaxButton from "../../../../shared/form/ajax_button";
import TextEditor from "../modules/text_editor";

export default function Settings() {
  const dispatch = useDispatch()
  const accountOrganization = useSelector((state) => state.accountOrganization)
  const accountOrganizationUpdateUrl = useSelector((state) => state.accountOrganizationUpdateUrl)
  const hostname = useSelector((state) => state.hostname)

  const [brandColor1, setBrandColor1] = useState(accountOrganization.brand_color_1 || "#0ECC46")
  const [brandColor2, setBrandColor2] = useState(accountOrganization.brand_color_2 || "#FFFFFF")
  const [supportChatNotAvailableEditorTextEditorState, setSupportChatNotAvailableEditorTextEditorState] = useState(accountOrganization.support_chat_not_available_text);
  const [supportChatAvailableEditorTextEditorState, setSupportChatAvailableEditorTextEditorState] = useState(accountOrganization.support_chat_available_text);
  const [leadGenerationTextState, setLeadGenerationTextState] = useState(accountOrganization.lead_generation_text);

  const generateRequestObject = () => {
    return {
      brand_color_1: brandColor1,
      brand_color_2: brandColor2,
      support_chat_not_available_text: supportChatNotAvailableEditorTextEditorState,
      support_chat_available_text: supportChatAvailableEditorTextEditorState,
      lead_generation_text: leadGenerationTextState
    }
  }

  return <div className="row no-gutters">
    <div className="col-12 px-5 pt-5">
      <div className="row shadow">
        <div className="col-12 p-4">
          <div className="row">
            <div className="col-md-8">
              <h1>Your account settings</h1>
              <p>
                Welcome to your account settings!
                <br/>
                <br/>
                {(hostname === "flaveueg22" || hostname === "flaveueg23") ? <>
                  Here you can manage the primary color used for your company profile page.
                </> : <>
                  Here you can manage the primary colour and text colour used for your booth.
                </>}
              </p>
            </div>
            <div className="col-md-4">
              <p>
                To save your changes click on the save button below.
              </p>
              <AjaxButton
                method="put"
                labelSending="Sending..."
                className={"btn btn-outline-success btn-ueg"}
                icon="fa-save"
                url={accountOrganizationUpdateUrl}
                data={generateRequestObject}
                label={"Save"}
                onSuccess={(data) => {
                  if (data.data.status === "OK") {
                    console.log("account_organization", data.data.account_organization)
                    dispatch(applyAccountOrganizationChanges(data.data.account_organization))
                  } else {
                    alert("Error updating hotspot")
                  }
                }}
                onError={(error) => {
                  console.log(error)
                  alert("A error occured", error)
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="col-xl-6 p-5">
      <div className="row shadow">
        <div className="col-md-6 p-4">
          <div className="row">
            <div className="col-12">
              <h5>Primary Colour</h5>
              <SketchPicker
                color={brandColor1}
                onChangeComplete={({hex}) => setBrandColor1(hex)}
              />
            </div>
            <div className="col-12">
              <hr/>
              <h5>Text Colour</h5>
              <SketchPicker
                color={brandColor2}
                onChangeComplete={({hex}) => setBrandColor2(hex)}
              />
            </div>
          </div>
        </div>
        <div className="col-md-6 p-4">
          <div className="modal preview-modal" role="dialog" tabIndex="-1"
               style={{position: "relative", background: "none", minHeight: "unset"}}>
            <div className="modal-dialog" role="document">
              <div className="modal-content shadow">
                <div className="modal-header" ref={(node) => {
                  if (node) {
                    node.style.setProperty("background-color", brandColor1, "important");
                    node.style.setProperty("color", brandColor2, "important");
                  }
                }}>
                  <div className="modal-title">
                    YOUR HEADER
                  </div>
                </div>
                <div className="modal-body">
                  <p>Some content ...</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="col-xl-6 p-5">
      <div className="row shadow">

      </div>
    </div>
    {accountOrganization.virtual_congress_chat_permission && 
      <>
        <div className="col-xl-6 p-5">
          <div className="row shadow">
            <div className="col-12 p-4">
              <h4>Support Chat available text</h4>
              <p>This message will be shown in support chats where the message is available.</p>
              <hr/>
              <TextEditor
                initialEditorState={{html: supportChatAvailableEditorTextEditorState}}
                onDataChanged={(data) => {
                  setSupportChatAvailableEditorTextEditorState(data.html)
                }}/>
            </div>
          </div>
        </div>
        <div className="col-xl-6 p-5">
          <div className="row shadow">
            <div className="col-12 p-4">
              <h4>Support Chat not available text</h4>
              <p>This message will be shown in support chats where the message is not available.</p>
              <hr/>
              <TextEditor
                initialEditorState={{html: supportChatNotAvailableEditorTextEditorState}}
                onDataChanged={(data) => {
                  setSupportChatNotAvailableEditorTextEditorState(data.html)
                }}/>
            </div>
          </div>
        </div>
      </>
    }
    {accountOrganization.virtual_congress_allow_leads_permission && 
      <div className="col-xl-6 p-5">
        <div className="row shadow">
          <div className="col-12 p-4">
            <h4>Lead Generation Text</h4>
            <p>This text will be shown in lead generation popups</p>
            <hr/>
            <TextEditor
              initialEditorState={{html: leadGenerationTextState}}
              onDataChanged={(data) => {
                setLeadGenerationTextState(data.html)
              }}/>
          </div>
        </div>
      </div>
    }
  </div>
}
